import { useEffect, useMemo, useState } from "react";

import {
  fetchKpis,
  fetchTimeseries,
  fetchYesNoSummary,
  fetchTopCategories,
} from "../../services/dashboardService";
import { getDashboardFiltersKey } from "../../utils/dashboard/queryParams";

export default function useDashboardOverviewData(filters, onErrorChange) {
  const [loading, setLoading] = useState(true);
  const [kpis, setKpis] = useState(null);
  const [tsSurveys, setTsSurveys] = useState([]);
  const [tsTemp, setTsTemp] = useState([]);
  const [yesno, setYesno] = useState(null);
  const [topSoil, setTopSoil] = useState([]);
  const [topAnimals, setTopAnimals] = useState([]);
  const [topWaste, setTopWaste] = useState([]);

  const filtersKey = getDashboardFiltersKey(filters);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        onErrorChange?.(null);

        const [
          kpisData,
          surveysTs,
          tempTs,
          yesnoData,
          soilData,
          animalData,
          wasteData,
        ] = await Promise.all([
          fetchKpis(filters),
          fetchTimeseries("surveys", filters),
          fetchTimeseries("tempSoil_mean", filters),
          fetchYesNoSummary(filters),
          fetchTopCategories("bloc1.soilType", filters, 5),
          fetchTopCategories("bloc4.animalCategory", filters, 5),
          fetchTopCategories("bloc5.wasteCategory", filters, 5),
        ]);

        if (cancelled) return;

        setKpis(kpisData);
        setTsSurveys(surveysTs.points || []);
        setTsTemp(tempTs.points || []);
        setYesno(yesnoData);
        setTopSoil(soilData.items || []);
        setTopAnimals(animalData.items || []);
        setTopWaste(wasteData.items || []);
      } catch (e) {
        if (!cancelled) {
          onErrorChange?.(e?.message || "Error carregant dades del dashboard");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters, onErrorChange]);

  const yesnoByKey = useMemo(() => {
    if (!yesno?.items) return {};
    const out = {};
    for (const it of yesno.items) out[it.key] = it;
    return out;
  }, [yesno]);

  return {
    loading,
    kpis,
    tsSurveys,
    tsTemp,
    yesno,
    yesnoByKey,
    topSoil,
    topAnimals,
    topWaste,
  };
}
